module.exports = __webpack_public_path__ + "img/garage.4784af15.png";